import React from "react";
import { Avatar, Tag } from "antd";
import { generateUniqueColor } from "utils";

const TagRecipient = _props => {
  const { value, closable, onClose, options } = _props;

  const selected = options.find(dt => dt.id === value);
  const { label, src } = selected || {};

  const onPreventMouseDown = _event => {
    _event.preventDefault();
    _event.stopPropagation();
  };
  return (
    <React.Fragment>
      {selected ? (
        <Tag
          color={value}
          onMouseDown={onPreventMouseDown}
          closable={closable}
          onClose={onClose}
          style={{
            marginRight: 3,
            display: "flex",
            gap: 8,
            alignItems: "center",
            backgroundColor: "#ECEEFD",
            color: "#1F2EB4",
            borderRadius: 12,
            height: 30,
            padding: "2px 8px",
            marginBottom: 5,
            marginTop: 5,
          }}
        >
          {typeof src === "string" && (
            <Avatar
              style={{
                backgroundColor: src ? "#fff" : generateUniqueColor(label),
                color: "#fff",
                textTransform: "uppercase",
                height: 24,
                width: 24,
              }}
              src={src}
            >
              {src ? "" : label.charAt(0)}
            </Avatar>
          )}
          {typeof src === "function" && (
            <Avatar
              style={{
                color: "#fff",
                textTransform: "uppercase",
                height: 24,
                width: 24,
              }}
              icon={src()}
            >
              {src ? "" : label.charAt(0)}
            </Avatar>
          )}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              width: "auto",
              maxWidth: 150,
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            <span style={{ fontWeight: 500, fontSize: 14 }}>{label}</span>
          </div>
        </Tag>
      ) : null}
    </React.Fragment>
  );
};

export default TagRecipient;
